import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { EMPTY_CHECK, checkPhone, phoneIssueMessage } from "@/lib/phoneCheck";

// Lot 560 — vérification en direct (anti-rebond 350 ms, bibliothèque chargée au 1er numéro tapé).
export const usePhoneCheck = (candidate, isoHint = "") => {
  const [check, setCheck] = useState(EMPTY_CHECK);
  useEffect(() => {
    const digits = (candidate || "").replace(/\D/g, "");
    if (digits.length < 4) { setCheck(EMPTY_CHECK); return undefined; }
    let alive = true;
    const id = setTimeout(() => {
      checkPhone(candidate, isoHint).then((c) => { if (alive) setCheck(c); }).catch(() => { if (alive) setCheck(EMPTY_CHECK); });
    }, 350);
    return () => { alive = false; clearTimeout(id); };
  }, [candidate, isoHint]);
  return check;
};

// Ligne d'alerte sous un champ numéro : rouge si l'envoi est bloqué (trop court / long), ambre si « douteux ».
// « Trop court » n'est affiché qu'une fois la saisie terminée (showShort) pour ne pas gêner pendant la frappe.
export const PhoneCheckHint = ({ check, lang, testId, showShort = true }) => {
  const { t } = useApp();
  if (!check || check.status === "unknown" || check.status === "ok") return null;
  if (check.status === "short" && !showShort) return null;
  const soft = check.status === "doubtful";
  return (
    <p className="text-[11px] leading-snug flex items-start gap-1" style={{ color: soft ? "#92400E" : "#B91C1C" }} data-testid={`${testId}-check`} data-status={check.status}>
      <AlertTriangle size={12} className="shrink-0 mt-0.5" /> <span>{phoneIssueMessage(check, t, lang)}</span>
    </p>
  );
};
